<div class="modal-header">
    <h5 class="modal-title">Appearance</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
    <div class="form-check">
        <input
            class="form-check-input"
            type="radio"
            name="app-theme"
            id="theme-light"
            [checked]="theme.theme() === 'light'"
            (change)="theme.setTheme('light')"
        />
        <label class="form-check-label" for="theme-light">Light</label>
    </div>
    <div class="form-check mb-0">
        <input
            class="form-check-input"
            type="radio"
            name="app-theme"
            id="theme-dark"
            [checked]="theme.theme() === 'dark'"
            (change)="theme.setTheme('dark')"
        />
        <label class="form-check-label" for="theme-dark">Dark (Beta)</label>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
</div>
